import axios from "axios";
import { decodeToken } from "react-jwt";
import React, { useState, useEffect } from "react";
import NotLoggedIn from "./cards/notLoggedIn";
import LoggedIn from "./cards/loggedIn";
import CreateMessage from "./cards/createMessage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginCard from "./cards/loginCard";
import MessageTimeline from "./cards/messageTimeline";

export default function TopCard(props) {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [isTrue, setIsTrue] = useState(false);
  const [isLoading, setLoadingState] = useState(false);
  const [isValidated, setisValidated] = useState();

  useEffect(() => {
    if (localStorage.getItem("userToken")) {
      setLoadingState(true);
      axios
        .post("https://secretsafe-backend.onrender.com/vertify-token", {
          token: localStorage.getItem("userToken"),
        })
        .then((response, err) => {
          if (err) {
          } else {
            setIsTrue(response.data.response);
            const decoded = decodeToken(localStorage.getItem("userToken"));
            setLink(generateUrl(decoded.id));
            props.setLoggedIn(true);
            setLoadingState(false);
          }
        });
    } else {
      localStorage.clear();
      setIsTrue(false);
      setLoadingState(false);
    }
  }, []);

  function submitName(event) {
    event.preventDefault();
    if (name.length > 1) {
      setisValidated(false);
      setLoadingState(true);
      axios
        .post("https://secretsafe-backend.onrender.com/create-account", {
          name,
        })
        .then((response) => {
          afterRequest(response);
          setLoadingState(false);
        });
    } else {
      setisValidated(true);
    }
  }

  const generateUrl = (id) => {
    return `${window.location.href + "msg/" + id}`;
  };

  function afterRequest(response) {
    const data = decodeToken(response.data.data);
    props.dataUpdate([response.data.data, data]);
    setIsTrue(data.isLoggedIn);
    setLink(generateUrl(data.id));
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/msg">
          <Route path=":id" element={<CreateMessage />} />
        </Route>
        <Route
          path="/"
          element={
            isTrue ? (
              <LoggedIn link={link} isLoading={isLoading} />
            ) : (
              <NotLoggedIn
                submitname={submitName}
                setname={setName}
                isvalidated={isValidated}
                isLoading={isLoading}
              />
            )
          }
        />
        <Route
          exact
          path="/login"
          element={
            <LoginCard
              isTrue={isTrue}
              setIsTrue={setIsTrue}
              isLoading={isLoading}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
